import { Divider, FormGroup } from '@ksyos/design-system';
import { HolterContainer } from './HolterContainer';
import { HolterCurrent } from './HolterCurrent';

export function HolterReadDownloadProgress(props: Readonly<{ downloadProgress?: number }>) {
    return (
        <>
            <FormGroup layout="vertical">
                <HolterContainer inModal>
                    {props.downloadProgress == 100 ? (
                        <HolterCurrent
                            appearance="success"
                            inModal={true}
                            text="Het bestand is uitgelezen en overgezet naar je computer. Je kunt de recorder loskoppelen. Het bestand wordt nu geüpload naar ons platform, zet de computer nog niet uit."
                        />
                    ) : (
                        <HolterCurrent
                            appearance="info"
                            isLoading={true}
                            text="De recorder wordt uitgelezen..."
                            uploadPercentage={props.downloadProgress ?? 0}
                        />
                    )}
                </HolterContainer>
            </FormGroup>
            <Divider spacing="small" />
        </>
    );
}
